import React, { useState } from "react";
import "./styles/SideBar.css";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../store/reducers/sidebarSlice";
import { NavLink } from "react-router-dom";

export default function SideBar() {
  const sidebar = useSelector((state) => state.sidebar);
  const dispatch = useDispatch();
  // console.log(sidebar.expand, "<<< sidebar");

  const [sideBarSmall, setSideBarSmall] = useState(false);

  return (
    <div className={`${!sidebar.expand ? "sideBarSmall" : "sideBarBig"}`}>
      {!sidebar.expand ? (
        <div className="sideBarSmallLogoContainer">
          <img
            src={require("../../assets/logo_small.png")}
            className="sideBarSmallLogo"
            alt="logo"
          />
          <img
            src={require("../../assets/sideBarMax.png")}
            className="sideBarSmallminimizer"
            alt="logo"
            // onClick={() => setSideBarSmall(false)}
            onClick={() => dispatch(expandSidebar())}
            // onClick={() => dispatch(collapseSidebar())}
          />
        </div>
      ) : (
        <div className="sideBarBigLogoContainer">
          <img
            src={require("../../assets/logo2.png")}
            className="sideBarBigLogo"
            alt="logo"
          />
          <img
            src={require("../../assets/sideBarMin.png")}
            className="sideBarBigminimizer"
            alt="logo"
            // onClick={() => setSideBarSmall(true)}
            onClick={() => dispatch(collapseSidebar())}
          />
        </div>
      )}
      <div
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/merchantIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {sidebar.expand && <div className="sideBarOptionsText">Merchant</div>}
      </div>
      <div
        className={`${
          !sidebar.expand ? "subOptionsContainerSmall" : "subOptionsContainer"
        }`}
      >
        <NavLink
          to="/"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          } firstSubOption`}
        >
          <img
            src={require("../../assets/verify.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">Merchant Verification </div>
          )}
        </NavLink>
        <NavLink
          to="/allMerchants"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          }`}
        >
          <img
            src={require("../../assets/all.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">All Merchants</div>
          )}
        </NavLink>
      </div>

      {/* Customer Module */}
      <div
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/userIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {sidebar.expand && <div className="sideBarOptionsText">Customer</div>}
      </div>
      <div
        className={`${
          !sidebar.expand ? "subOptionsContainerSmall" : "subOptionsContainer"
        }`}
      >
        <NavLink
          to="/allCustomers"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          } firstSubOption`}
        >
          <img
            src={require("../../assets/all.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">All Customers</div>
          )}
        </NavLink>
      </div>

      <div
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/chat.png")}
          className="sideBarOptionsIcon"
          style={{ width: "1.3vw", height: "1.3vw" }}
          alt="logo"
        />
        {sidebar.expand && <div className="sideBarOptionsText">Chat </div>}
      </div>
      <div
        className={`${
          !sidebar.expand ? "subOptionsContainerSmall" : "subOptionsContainer"
        }`}
      >
        <NavLink
          to="/chat"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          } firstSubOption`}
        >
          <img
            src={require("../../assets/chatAdmin.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">Chat Admin </div>
          )}
        </NavLink>
        <NavLink
          to="/chat/keywordSearch"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          }`}
        >
          <img
            src={require("../../assets/globalSearch.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">Keyword Search</div>
          )}
        </NavLink>
      </div>
      <div
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/chat.png")}
          className="sideBarOptionsIcon"
          style={{ width: "1.3vw", height: "1.3vw" }}
          alt="logo"
        />
        {sidebar.expand && <div className="sideBarOptionsText">Project </div>}
      </div>
      <div
        className={`${
          !sidebar.expand ? "subOptionsContainerSmall" : "subOptionsContainer"
        }`}
      >
        <NavLink
          to="/VerifyProject"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          } firstSubOption`}
        >
          <img
            src={require("../../assets/chatAdmin.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">Verify Project </div>
          )}
        </NavLink>
        <NavLink
          to="/allprojects"
          className={`${
            !sidebar.expand
              ? "sideBarOptionsSubContainerSmall"
              : "sideBarOptionsSubContainer"
          }`}
        >
          <img
            src={require("../../assets/globalSearch.png")}
            className="sideBarOptionsSubIcon"
            alt="logo"
          />
          {sidebar.expand && (
            <div className="sideBarOptionsSubText">All Projects </div>
          )}
        </NavLink>
      </div>
      {/* <NavLink
        to="/project"
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/userIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {sidebar.expand && (
          <div className="sideBarOptionsText">Project Verify</div>
        )}
      </NavLink> */}
      {/* <div
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/paymentIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {sidebar.expand && <div className="sideBarOptionsText">Payments</div>}
      </div>
      <div
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/supportIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {sidebar.expand && <div className="sideBarOptionsText">Support</div>}
      </div> */}
      <NavLink
        to="/commission"
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/settings.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {/* {sidebar.expand && <div className="sideBarOptionsText">Users</div>} */}
        {sidebar.expand && (
          <div className="sideBarOptionsText">Commissions</div>
        )}
      </NavLink>
      <NavLink
        to="/withdrawal"
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/paymentIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {/* {sidebar.expand && <div className="sideBarOptionsText">Users</div>} */}
        {sidebar.expand && (
          <div className="sideBarOptionsText">Withdrawals</div>
        )}
      </NavLink>
      <NavLink
        to="/support"
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/supportIcon.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {/* {sidebar.expand && <div className="sideBarOptionsText">Users</div>} */}
        {sidebar.expand && <div className="sideBarOptionsText">Support</div>}
      </NavLink>
      <NavLink
        to="/coupon"
        className={`${
          !sidebar.expand
            ? "sideBarOptionsContainerSmall"
            : "sideBarOptionsContainer"
        }`}
      >
        <img
          src={require("../../assets/verify.png")}
          className="sideBarOptionsIcon"
          alt="logo"
        />
        {/* {sidebar.expand && <div className="sideBarOptionsText">Users</div>} */}
        {sidebar.expand && <div className="sideBarOptionsText">Coupon</div>}
      </NavLink>
    </div>
  );
}
